// extracted by mini-css-extract-plugin
module.exports = {"divider":"styles_divider__3NsEo","dash":"styles_dash__1ir_1","dashMain":"styles_dashMain__28gSn"};